import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiHint, TuiFallbackSrcPipe, TuiInitialsPipe, TuiAutoColorPipe, TuiButton } from '@taiga-ui/core';
import { TuiAvatar, TuiPreview, TuiSkeleton } from '@taiga-ui/kit';
import { SharedModule } from '@src/app/shared';
import { IconModule } from '@src/app/modules/icon';

import { BasePhotoComponent } from './base-photo.component';
import { PhotoEditComponent } from './photo-edit/photo-edit.component';
import { PhotoViewComponent } from './photo-view/photo-view.component';
import { PhotoPreviewComponent } from './photo-preview/photo-preview.component';

/**
 * @module PhotoModule
 * @description Модуль для работы (отображение и редактирование) с картинкой объекта
 */
@NgModule({
  declarations: [BasePhotoComponent, PhotoEditComponent, PhotoViewComponent, PhotoPreviewComponent],
  imports: [
    CommonModule,
    IconModule,
    SharedModule,
    TuiAvatar,
    ...TuiHint,
    TuiFallbackSrcPipe,
    TuiInitialsPipe,
    TuiAutoColorPipe,
    TuiSkeleton,
    ...TuiPreview,
    TuiButton,
  ],
  exports: [BasePhotoComponent],
})
export class BasePhotoModule {}
